module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "intro-videos"
  }, [(_vm.terms) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("These Videos show up per group, per week - a personalized video each week for how things are going!")]), _vm._v(" "), (_vm.terms) ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body add-weekly-video"
  }, [_c('p', [_vm._v("Below you can add your personalized weekly intro videos, per week")]), _vm._v(" "), (_vm.supervisorGroups) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addVideo()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Term")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.term),
      expression: "term"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.term = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.terms), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.name))])
  })), _vm._v(" "), _c('label', [_vm._v("Week")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.week),
      expression: "week"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.week = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Pre-term")]), _vm._v(" "), _vm._l((_vm.weeks), function(week) {
    return _c('option', {
      domProps: {
        "value": week
      }
    }, [_vm._v("Week " + _vm._s(week))])
  })], 2), _vm._v(" "), _c('label', [_vm._v("Group")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGroup),
      expression: "selectedGroup"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.supervisorGroups), function(group) {
    return (group.term == _vm.term) ? _c('option', {
      domProps: {
        "value": group.id
      }
    }, [_vm._v("\n                                    Group " + _vm._s(group.label) + "\n                                ")]) : _vm._e()
  })), _vm._v(" "), _c('input', {
    ref: "supervisorVideo",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "video/mp4"
    },
    on: {
      "change": function($event) {
        _vm.validateFileType()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add")])])]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.videos), function(videos, term) {
    return _c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "panel-heading cursor-pointer",
      on: {
        "click": function($event) {
          _vm.selectedTerm === term ? _vm.selectedTerm = null : _vm.selectedTerm = term
        }
      }
    }, [_c('h4', [_vm._v("\n                                " + _vm._s(_vm.formatDate(term)) + "\n                                "), (_vm.selectedTerm === term) ? _c('i', {
      staticClass: "fa fa-caret-down"
    }) : _c('i', {
      staticClass: "fa fa-caret-right"
    })])]), _vm._v(" "), (_vm.selectedTerm === term) ? _c('div', {
      staticClass: "panel-body videos-table"
    }, _vm._l((videos), function(video) {
      return _c('div', {
        staticClass: "video"
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "week"
      }, [(video.week < 1) ? _c('span', [_vm._v("Pre-Term")]) : _c('span', [_vm._v("Week " + _vm._s(video.week))])]), _vm._v(" "), _c('div', [_vm._v("\n                                        " + _vm._s(video.groups[0].label || video.groups[0]) + "\n                                    ")]), _vm._v(" "), _c('div', [_c('button', {
        staticClass: "btn btn-danger",
        on: {
          "click": function($event) {
            _vm.deleteVideo(video.id)
          }
        }
      }, [_vm._v("Delete")])]), _vm._v(" "), _c('div', [_c('a', {
        attrs: {
          "href": video.url,
          "target": "_blank"
        }
      }, [_vm._v("Link")])]), _vm._v(" "), _c('div', {
        staticClass: "cursor-pointer video-thumbnail",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.selectedVideo === video.id ? _vm.selectedVideo = null : _vm.selectedVideo = video.id
          }
        }
      }, [_c('img', {
        attrs: {
          "src": require("../assets/img/play-button.png")
        }
      }), _vm._v(" "), _c('video', {
        attrs: {
          "width": "100"
        }
      }, [_c('source', {
        attrs: {
          "src": video.url
        }
      })])])]), _vm._v(" "), (_vm.selectedVideo === video.id) ? _c('div', {
        staticClass: "player"
      }, [_c('poly-video', {
        key: _vm.selectedVideo.id,
        ref: "videoPlayer",
        refInFor: true,
        attrs: {
          "sources": [video.url],
          "persistPlaybackSpeed": true
        }
      })], 1) : _vm._e()])
    })) : _vm._e()])
  })], 2) : _vm._e()]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Add a Weekly Intro Video")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-750595aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IntroVideos.vue
// module id = 2081
// module chunks = 2